import React, { Component } from 'react'

class Counter extends Component {
  render() {
    return (
      <>
        {this.props.counts2}
        <div>
            <button
            onClick={this.props.incrementCounter}
            >
            Add Counter
            </button>
        </div>
      </>
    )
  }
}

export default Counter
